// The theme keeps tooltips in place (disablePortal); the dots sit inside highlighted values that clip
// their overflow on read-only views, so their tooltip renders in a portal instead.
export const AUTHOR_DOTS_POPPER_PROPS = { disablePortal: false };
